module.exports = __webpack_public_path__ + "img/default-logo-7.88c592ba.png";